import { create } from 'zustand';

/**
 * Open and close state for the shell, in one place.
 *
 * Section 12: "Centralise open and close state in one place rather than
 * toggling classes from several call sites." The reported bug where opening the
 * menu turned the whole screen into a dead overlay came from two call sites
 * disagreeing about who owned the scrim, so the scrim here is derived from the
 * panels rather than toggled by them.
 */
interface ShellState {
  navOpen: boolean;
  drawerOpen: boolean;
  openNav: () => void;
  closeNav: () => void;
  openDrawer: () => void;
  closeDrawer: () => void;
  closeAll: () => void;
}

export const useShellStore = create<ShellState>((set) => ({
  navOpen: false,
  drawerOpen: false,
  openNav: () => set({ navOpen: true }),
  closeNav: () => set({ navOpen: false }),
  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),
  closeAll: () => set({ navOpen: false, drawerOpen: false }),
}));

/** The scrim belongs to whichever panel is open, and to no panel when none is. */
export function useScrimVisible(): boolean {
  return useShellStore((state) => state.navOpen || state.drawerOpen);
}
